export default __webpack_public_path__ + "static/media/create_skills.f9aa7c75.svg";